import { type Token } from '@/shared/assets/tokens';
import { SkeletonLine } from '@/shared/components/atoms/LoadingSkeleton';
import useTokenPrice from '@/shared/hooks/useTokenPrice';
import { formatUsdValue } from '@/shared/utils/numbers';
import type TokenAmount from '@/shared/utils/TokenAmount';

export const UsdAmount = ({
  token,
  tokenAmount,
  withParens,
}: {
  token: Token | undefined;
  tokenAmount: TokenAmount | undefined;
  withParens?: boolean;
}) => {
  const { price, isLoading } = useTokenPrice(token);

  if (!tokenAmount) {
    if (withParens) return `(${formatUsdValue(0)})`;
    return formatUsdValue(0);
  }
  if (!price && isLoading) return <SkeletonLine width={30} inline />;
  if (!price) return null;

  const formatted = formatUsdValue(tokenAmount.mul(price).toBigNumber());
  if (formatted.includes('NaN')) return null;

  return withParens ? `(${formatted})` : formatted;
};
